import Search, { SearchProps } from './Search';
import { useBrandContext } from 'context/BrandProvider';
import AccentImage from './AccentImage';
import { FC, useMemo } from 'react';
import { generateBrandGradient } from 'api/brand/utils';

const Hero: FC<SearchProps> = ({
  onLoadingDone,
  setAddressValue,
  addressValue,
}) => {
  const { brand } = useBrandContext();

  const gradientStyle = useMemo(() => {
    return generateBrandGradient(brand?.primaryColor, brand?.accentColor);
  }, [brand?.primaryColor, brand?.accentColor]);

  return (
    <div className="relative z-10 flex flex-col items-center px-4 pt-[100px]">
      <div>
        <div className="z-20 flex flex-col gap-8">
          <div className="flex w-full flex-col font-bold">
            <p className="text-center text-[40px] text-content-base-default xl:text-[52px]">
              {brand?.lpTaglineTopRow ?? 'The future of telecom'}
            </p>
            <div
              className="inline-block bg-clip-text text-transparent"
              style={{
                backgroundImage: gradientStyle,
              }}
            >
              <p className="text-center text-[40px] xl:text-[52px]">
                {brand?.lpTaglineBottomRow ?? 'at your fingertips'}
              </p>
            </div>
          </div>
          <p className="mb-8 text-center text-xl text-content-base-subdued">
            {brand?.lpSubtext ??
              'Customizable network solutions made simple with AccessExpress.'}
          </p>
        </div>
      </div>
      <Search
        addressValue={addressValue}
        setAddressValue={setAddressValue}
        onLoadingDone={onLoadingDone}
      />
      <div className="mt-[60px]">
        <AccentImage />
      </div>
    </div>
  );
};

export default Hero;
